var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{'admin': _vm.isAdmin, 'frontend': !_vm.isAdmin }},[_c('div',{attrs:{"id":"nav"}},[(!_vm.isAdmin)?_c('Nav'):_vm._e()],1),_c('router-view'),(!_vm.isAdmin)?_c('Footer'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }